import $ from 'jquery';

class Footnotes {
    constructor() {
        this.$window       = $(window);
        this.$stickyHeader = $('.js-header');
        this.$footnote     = $('.js-footnote');
        this.$footnoteRef  = $('.js-footnote-ref');

        // Apply an offset if there is a sticky header
        this.footnoteSpacingOffset = this.$stickyHeader.outerHeight(true) + 40;

        this.$footnoteRef.on('click', $.proxy(this.goToFootnote, this));
        this.$footnote.on('click', $.proxy(this.goToFootnoteRef, this));
    }

    // Scroll from footnote ref to the footnote itself
    goToFootnote(e) {
        const footnoteRef = e.currentTarget;
        const footnoteID  = $(footnoteRef).data('footnote');
        const $footnote   = $(footnoteID);

        $('body,html').animate({
            scrollTop: $footnote.offset().top - this.footnoteSpacingOffset
        });
    }

    // Scroll from footnote back to the footnote ref
    goToFootnoteRef(e) {
        const footnote      = e.currentTarget;
        const footnoteRefID = $(footnote).data('footnote-ref');
        const $footnoteRef  = $(footnoteRefID);

        $('body,html').animate({
            scrollTop: $footnoteRef.offset().top - this.footnoteSpacingOffset
        });
    }
}

export default Footnotes;
